/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Confirm_CrumbInputs */

const en_booking_confirm_crumb = /** @type {(inputs: Booking_Confirm_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your visit`)
};

const pl_booking_confirm_crumb = /** @type {(inputs: Booking_Confirm_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja wizyta`)
};

/**
* | output |
* | --- |
* | "Your visit" |
*
* @param {Booking_Confirm_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_confirm_crumb = /** @type {((inputs?: Booking_Confirm_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Confirm_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_confirm_crumb(inputs)
	return en_booking_confirm_crumb(inputs)
});